import React, { useState } from 'react'
import styles from './profilebody.module.css';
import EditBilling from '../addEditAddress/EditBilling';
import AddBilling from '../addEditAddress/AddBilling';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setCustomerEditData } from '../../../../Website/redux/customerSlice';
import AddressTable from './AddressTable';

const BilingAddress = () => {
    const [isAddPopupOpen, setAddPopupOpen] = useState(false);
    const [isEditPopupOpen, setEditPopupOpen] = useState(false);
    const dispatch = useDispatch()
    const { customer } = useSelector((state) => state.customer)

    const openAddShipPopup = () => {
        dispatch(setCustomerEditData({}))
        setAddPopupOpen(true);
    };

    const handleEditClick = async (data) => {
        await dispatch(setCustomerEditData(data))
        setEditPopupOpen(true)
    }
    return (
        <div className={styles.profilebodyContainer}>
            <div className={styles.profileheader}>
                <h2>Billing Address</h2>
                <button className={styles.savechanges} onClick={openAddShipPopup}>Add New Addres</button>
                {isAddPopupOpen &&
                    <AddBilling
                        onClose={() => setAddPopupOpen(false)}
                        heading={'Add New Billing Address'}
                        from="cba"
                        parent="billing"
                    />
                }
            </div>
            <div className={styles.profilebodyContent}>

                <div className={styles.address_container}>
                    {customer?.billingAddress?.length > 0 ?
                        <>
                            <AddressTable
                                heading="Billing"
                                customer={customer}
                                addressData={customer?.billingAddress}
                                handleEditClick={handleEditClick}

                            />
                            {isEditPopupOpen &&
                                <AddBilling
                                    onClose={() => setEditPopupOpen(false)}
                                    heading={'Edit New Billing Address'}
                                    from="cbe"
                                    parent="billing"
                                />
                            }
                        </>
                        :
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>No Address found</div>
                    }
                </div>
            </div>

        </div>
    )
}

export default BilingAddress